<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Absensi
        </li>

        <li class="breadcrumb-item">
          <a href="#/absen-bulan-import">Import Absensi</a>
        </li>
      </ol>
    </nav>

    <LogPopupTemplate ref="logPopup" />
    <DxPopup
      :visible="popupGenerateVisible"
      title="Konfirmasi data pegawai"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="400"
      :height="210"
    >
      <div>
        <p>
          <strong>Pastikan data pegawai sudah terupdate.</strong>
        </p>
        <p>
          <strong
            >Update data jabatan, pekerjaan dan status pegawai aktif atau
            pensiun</strong
          >
        </p>
      </div>
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptions"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="confirmButtonOptionsGenerate"
      />
    </DxPopup>

    <DxPopup
      :visible="popupWarningRefreshPegawaiVisible"
      title="Peringatan Refresh Data Pegawai"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="400"
      :height="400"
    >
      <div>
        <p v-html="popupWarningRefreshPegawaiText"></p>
      </div>
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptions"
      />
    </DxPopup>

    <h5 class="content-block">
      Daftar Absensi
      <span>
        <!-- @click="absenStore.onMuatButtonClick()" -->
        <!-- <DxButton
          :visible="buttonFilterPintasanVisible"
          icon="refresh"
          @click="hilangFilter('dataGrid')"
          text="Hilangkan filter dari pintasan"
          type="danger"
          styling-mode="outlined"
          style="float: right"
        ></DxButton> -->
        <DxButton
          icon="refresh"
          @click="refreshDatagrid"
          text="Refresh Data"
          type="default"
          style="float: right"
          styling-mode="outlined"
        ></DxButton>
      </span>

      <span>
        <DxButton
          v-if="false"
          icon="edit"
          @click="settingLiburDialog()"
          text="Setting Hari Libur/Cuti Bersama Pegawai"
          type="default"
          style="float: right"
          styling-mode="outlined"
        ></DxButton>
      </span>
      <span>
        <DxButton
          v-if="buttonCan('absensi-create')"
          icon="add"
          @click="setActionInput()"
          text="Buat Absensi"
          type="default"
          style="float: right"
          styling-mode="filled"
        ></DxButton>
      </span>
    </h5>

    <div class="content-block" v-if="actionInput">
      <div class="dx-card responsive-paddings">
        <p class="text-muted font-weight-light">Buat Daftar Absensi</p>
        <div class="row">
          <!-- <div class="editors"> -->
          <div class="editors-container">
            <div class="col">
              <DxSelectBox
                :dataSource="bulanSource"
                valueExpr="val"
                displayExpr="name"
                width="100%"
                label="Periode Bulan"
                placeholder="Periode Bulan"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.bulan"
              >
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="tahunSource"
                width="100%"
                label="Periode Tahun"
                placeholder="Periode Tahun"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.tahun"
              >
              </DxSelectBox>
            </div>

            <div class="col" style="padding-left: 10px">
              <DxButton
                @click="confirmGenerateAbsen"
                text="Buat Daftar Absensi"
                styling-mode="filled"
                type="default"
                class="validate"
                style="float: left"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <DxPopup
      :visible="popupLoadingVisible"
      :title="popupLoadingTitle"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="130"
    >
      <div class="d-flex justify-content-center">
        <div
          class="spinner-border"
          style="width: 3rem; height: 3rem"
          role="status"
        ></div>
      </div>
    </DxPopup>

    <DxPopup
      v-if="settingLiburSource"
      :visible="popupSettingLiburVisible"
      title="Konfigurasi Setting Libur/Cuti Bersama Pegawai"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      :height="500"
      :width="550"
    >
      <div class="dx-fieldset">
        <div class="dx-field">
          <div class="dx-field-label">Periode Absensi</div>
          <div class="dx-field-value">
            <DxDateBox
              :show-clear-button="true"
              :use-mask-behavior="true"
              :input-attr="{ 'aria-label': 'Date' }"
              type="date"
              displayFormat="monthAndYear"
              :calendar-options="calendarMonthYear"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              v-model="settingLiburSource.tgl"
            >
              <DxValidator>
                <DxRequiredRule />
              </DxValidator>
            </DxDateBox>
          </div>
        </div>
      </div>
      <div class="dx-fieldset">
        <div class="dx-fieldset-header">
          Jumlah Hari Libur/Cuti Bersama Per Status Pegawai
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Direksi</div>
          <div class="dx-field-value">
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Direksi"
              v-model="settingLiburSource.direksi"
            >
              <DxValidator>
                <DxNumericRule message="Data adalah angka" />
              </DxValidator>
            </DxTextBox>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Pegawai Tetap</div>
          <div class="dx-field-value">
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Pegawai Tetap"
              v-model="settingLiburSource.tetap"
            >
              <DxValidator>
                <DxNumericRule message="Data adalah angka" />
              </DxValidator>
            </DxTextBox>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Calon Pegawai</div>
          <div class="dx-field-value">
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Calon Pegawai"
              v-model="settingLiburSource.capeg"
            >
              <DxValidator>
                <DxNumericRule message="Data adalah angka" />
              </DxValidator>
            </DxTextBox>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Pekerja Honor</div>
          <div class="dx-field-value">
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Pekerja Honor"
              v-model="settingLiburSource.honor"
            >
              <DxValidator>
                <DxNumericRule message="Data adalah angka" />
              </DxValidator>
            </DxTextBox>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Pekerja Kontrak</div>
          <div class="dx-field-value">
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Pekerja Kontrak"
              v-model="settingLiburSource.kontrak"
            >
              <DxValidator>
                <DxNumericRule message="Data adalah angka" />
              </DxValidator>
            </DxTextBox>
          </div>
        </div>
      </div>

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptions"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="confirmButtonOptions"
      />
    </DxPopup>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <!-- <DxDataGrid
          ref="dataGrid"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @exporting="onExporting"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :remote-operations="true"
          :focused-row-enabled="true"
          :focused-row-index="0"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
        > -->
        <DxDataGrid
          :focused-row-enabled="true"
          :focused-row-index="0"
          ref="dataGrid"
          :data-source="absenStore.dataSourceAbsenList"
          :allow-column-reordering="true"
          :show-borders="true"
          key-expr="id"
          @editor-preparing="oneditorpreparing"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @exporting="onExporting"
          @saving="onSaving"
          @editing-start="editingStart"
          @option-changed="onPageChanged($event, 'dataGrid')"
          @row-updating="onRowUpdating($event, 'dataGrid')"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :remote-operations="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
          @context-menu-preparing="onContextMenuPreparing"
        >
          <DxHeaderFilter :visible="true" />

          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxPager
            :visible="true"
            :showPageSizeSelector="false"
            :showNavigationButtons="false"
            :show-info="true"
            :infoText="'Page {0} of {1} ({2} items)'"
          />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" />
          <!--  -->
          <DxEditing
            :allow-updating="can('absensi-update')"
            :allow-deleting="false"
            :allow-adding="false"
            mode="batch"
          />
          <!-- mode="batch" -->
          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>

          <!-- <DxSelection mode="multiple" /> -->
          <DxColumnFixing :enabled="true" />
          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="pegawai_id"
            data-type="number"
            caption="Opsi"
            :allow-exporting="false"
            :allow-edititng="false"
            :allow-filtering="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="getOptions(data)"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>

          <DxColumn
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
            data-type="number"
            :allowHeaderFiltering="false"
          />

          <DxColumn
            class="noteditable"
            data-field="gajis_status_gaji"
            caption="Status Gaji"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.statusGajiSource }"
            :customize-text="commonFunction.showStatusGaji"
            :show-editor-always="false"
          >
          </DxColumn>

          <template #periodeAbsenTemplate="{ data }">
            {{ formatMonth(data.text) }}
          </template>
          <DxColumn
            class="noteditable"
            data-type="string"
            data-field="simpeg_pegawais_nik"
            caption="NIK"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
          >
          </DxColumn>

          <DxColumn
            data-field="simpeg_pegawais_nama"
            caption="Nama Pegawai"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
            :min-width="200"
          >
          </DxColumn>
          <DxColumn
            data-field="periode_absen"
            caption="Periode Absen"
            data-type="date"
            :display-format="'MM/yyyy'"
            :format="'MM/yyyy'"
            :filter-operations="filterOperations"
            :fixed="true"
            fixed-position="left"
            :customize-text="commonFunction.formatIsoDateToMonthYear"
            :allowHeaderFiltering="false"
          >
          </DxColumn>
          <DxColumn
            dataField="status_aktifs_nama"
            caption="Status Aktif"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.statusAktifSource }"
          />
          <DxColumn
            dataField="cabangs_nama"
            caption="Cabang"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.cabangSource }"
          >
          </DxColumn>

          <DxColumn
            dataField="units_nama"
            caption="Unit"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.unitSource }"
          >
          </DxColumn>

          <DxColumn
            dataField="pegawai_statuses_nama"
            caption="Status Pegawai"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.pegawaiStatusSource }"
          >
          </DxColumn>

          <template #headerTemplate>
            <div
              class="small-button-container"
              style="display: inline-flex; align-items: center"
            >
              <DxButton
                :icon="isExpanded ? 'chevrondown' : 'chevronnext'"
                @click="toggleHeaderExpand"
              />
              <span style="margin-left: 8px">Pekerjaan</span>
            </div>
          </template>

          <DxColumn
            caption="Pekerjaan"
            header-cell-template="headerTemplate"
            :allow-hiding="false"
            :allowHeaderFiltering="false"
            :min-width="150"
          >
            <DxColumn
              data-field="jabatans_nama"
              caption="Jabatan"
              :allowHeaderFiltering="true"
              :header-filter="{ dataSource: commonStore.jabatanSource }"
              :visible="isExpanded"
            />

            <DxColumn
              dataField="bagians_nama"
              caption="Bagian"
              :allowHeaderFiltering="true"
              :header-filter="{ dataSource: commonStore.bagianSource }"
              :visible="isExpanded"
            >
            </DxColumn>

            <DxColumn
              dataField="sub_bagians_nama"
              caption="Sub Bagian"
              :allowHeaderFiltering="true"
              :header-filter="{ dataSource: commonStore.subBagianSource }"
              :visible="isExpanded"
            >
            </DxColumn>
            <DxColumn
              dataField="bidangs_nama"
              caption="Bidang"
              :allowHeaderFiltering="true"
              :header-filter="{ dataSource: commonStore.bidangSource }"
              :visible="isExpanded"
            >
            </DxColumn>
            <DxColumn
              dataField="sub_bidangs_nama"
              caption="Sub Bidang"
              :allowHeaderFiltering="true"
              :header-filter="{ dataSource: commonStore.subBidangSource }"
              :visible="isExpanded"
            >
            </DxColumn>
            <DxColumn
              dataField="seksis_nama"
              caption="Seksi"
              :allowHeaderFiltering="true"
              :header-filter="{ dataSource: commonStore.seksiSource }"
              :visible="isExpanded"
            >
            </DxColumn>
          </DxColumn>

          <DxColumn
            data-field="hadir"
            caption="Hadir"
            data-type="number"
            :allowHeaderFiltering="false"
          ></DxColumn>

          <DxColumn
            data-field="sakit"
            data-type="number"
            caption="Sakit"
            :set-cell-value="setCellValueSakit"
            :allowHeaderFiltering="false"
          ></DxColumn>
          <DxColumn
            data-field="ijin"
            data-type="number"
            caption="Ijin"
            :set-cell-value="setCellValueIjin"
            :allowHeaderFiltering="false"
          ></DxColumn>
          <DxColumn
            data-field="alpa"
            data-type="number"
            caption="Alpa"
            :set-cell-value="setCellValueAlpa"
            :allowHeaderFiltering="false"
          ></DxColumn>
          <DxColumn
            data-field="cuti"
            data-type="number"
            caption="Cuti"
            :set-cell-value="setCellValueCuti"
            :allowHeaderFiltering="false"
            :allow-editing="false"
            :allow-sorting="false"
            :allow-filtering="false"
          ></DxColumn>
          <!-- <DxColumn
            data-field="libur"
            data-type="number"
            caption="Libur/Cuti Bersama"
            :set-cell-value="setCellValueLibur"
            :allowHeaderFiltering="false"
          ></DxColumn> -->
          <DxColumn
            data-field="tidak_hadir"
            data-type="number"
            caption="Tdk Hadir"
            css-class="cell-highlighted"
            :allowHeaderFiltering="false"
          ></DxColumn>
          <DxColumn
            caption="Dibuat oleh"
            :allowHeaderFiltering="false"
            data-field="created_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxColumn
            caption="Diubah oleh"
            :allowHeaderFiltering="false"
            data-field="updated_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />
          <DxSummary>
            <DxTotalItem
              column="id"
              summary-type="count"
              value-format="#,##0"
            />
            <DxTotalItem
              column="hadir"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="sakit"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="ijin"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="alpa"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="cuti"
              summary-type="sum"
              value-format="#,##0"
            />
            <!-- <DxTotalItem
              column="libur"
              summary-type="sum"
              value-format="#,##0"
            /> -->
            <DxTotalItem
              column="tidak_hadir"
              summary-type="sum"
              value-format="#,##0"
            />
          </DxSummary>
        </DxDataGrid>

        <div
          style="
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 10px;
            margin-top: 10px;
          "
        >
          <DxDateBox
            :styling-mode="stylingMode"
            :label-mode="labelMode"
            :input-attr="{ 'aria-label': 'Periode DUK' }"
            display-format="MMMM yyyy"
            type="date"
            picker-type="calendar"
            :open-on-field-click="true"
            :calendar-options="{
              maxZoomLevel: 'year',
              minZoomLevel: 'year',
            }"
            label="Refresh Data Pegawai"
            placeholder="Pilih Periode Absen"
            v-model="refreshPegawaiTgl"
          />
          <DxButton
            icon="refresh"
            @click="refreshPegawaiConfirm"
            v-if="can('absensi-create')"
            text="Refresh Data Pegawai"
            type="default"
            styling-mode="outlined"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import * as commonFunction from "@/utils/common-function.js";
import DxSelectBox from "devextreme-vue/select-box";
import { useAbsenStore } from "@/stores/views/absen-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import { confirm } from "devextreme/ui/dialog";
import auth from "@/auth";
import api from "@/api";
import can from "@/haspermission";
import { API_BASE_URL } from "@/global-constants";
import axios from "axios";
import notify from "devextreme/ui/notify";
import {
  DxValidator,
  DxRequiredRule,
  DxNumericRule,
} from "devextreme-vue/validator";
import DxButton from "devextreme-vue/button";
import { DateTime } from "luxon";
// import DataSource from "devextreme/data/data_source";
import _ from "lodash";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  // DxItem,
  DxScrolling,
  DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";

import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";

import { ref } from "vue";

const months = [
  { name: "Januari", val: "01" },
  { name: "Februari", val: "02" },
  { name: "Maret", val: "03" },
  { name: "April", val: "04" },
  { name: "Mei", val: "05" },
  { name: "Juni", val: "06" },
  { name: "Juli", val: "07" },
  { name: "Agustus", val: "08" },
  { name: "September", val: "09" },
  { name: "Oktober", val: "10" },
  { name: "November", val: "11" },
  { name: "Desember", val: "12" },
];

const currentYear = DateTime.now().toFormat("yyyy");
const currentMonth = DateTime.now().toFormat("MM");
const years = [
  Number(currentYear) - 1,
  currentYear,
  Number(currentYear) + 1,
  // Number(currentYear) + 2,
  // Number(currentYear) + 3,
];
/* eslint-disable */
export default {
  components: {
    LogPopupTemplate,
    confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    DxButtonDatagrid,

    DxPopup,
    DxToolbarItem,
    // DxItem,
    DxDropDownButton,
    DxValidator,
    DxRequiredRule,
    DxNumericRule,
    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
    DxSelectBox,
  },
  setup() {
    const refreshPegawaiTgl = ref(DateTime.now().set({ day: 1 }).toISODate());
    const absenStore = useAbsenStore();

    const commonStore = useCommonStore();

    const summaryValuesTidakHadir = ref(0);

    const updateSummaryValue = (x) => {
      // console.log("UPDATE SUMMARY BITCH");
      summaryValuesTidakHadir.value = x; // Update the value
    };

    // updateSummaryValue("inside");

    return {
      refreshPegawaiTgl,
      commonStore,
      commonFunction,
      absenStore,
      summaryValuesTidakHadir,
      updateSummaryValue,
    };
  },
  data() {
    return {
      logPopupRef: null,
      popupWarningRefreshPegawaiVisible: false,
      isExpanded: true,
      popupGenerateVisible: false,
      popupLoadingTitle: "Loading...",
      cancelButtonOptions: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popupGenerateVisible = false;
          this.popupLoadingVisible = false;
          this.popupSettingLiburVisible = false;
          this.popupWarningRefreshPegawaiVisible = false;
          this.popupLoadingTitle = "Loading...";
        },
      },

      confirmButtonOptionsGenerate: {
        text: "Ya, Data Pegawai terupdate",
        onClick: () => {
          this.popupGenerateVisible = false;
          this.absenCheckExists();
        },
      },

      invalidRows: new Set(), // Track invalid rows

      actionInput: false,
      bulan: currentMonth,
      tahun: currentYear,

      dataSource: null,
      filters: {
        bulan: currentMonth,
        tahun: currentYear,
      },

      bulanSource: months,
      tahunSource: years,

      filterOperations: ["=", "<>", ">", "<", "between"],
      filterValue: [],
      // filterValue: [["periode_absen", "=", new Date(currentDate)]],

      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",
      settingLiburSource: {
        tgl: null,
        direksi: null,
        tetap: null,
        capeg: null,
        honor: null,
        kontrak: null,
        updated_by_user_id: auth.getUser().id,
      },
      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],

      statusGajiSource: [
        { val: true, nama: "Approved" },
        { val: false, nama: "Belum Approved" },
      ],

      numberingPageSize: 100,
      numberingPageNumber: 0,
      // dataSource: dataSource,
      buttonFilterPintasanVisible: false,
      pegawaiStatusSource: null,

      popupLoadingVisible: false,
      popupSettingLiburVisible: false,
      calendarMonthYear: {
        maxZoomLevel: "year",
        minZoomLevel: "century",
      },
      dataSource: null,

      confirmButtonOptions: {
        text: "Simpan",
        onClick: (e) => {
          let result = confirm(
            "<i>Yakin input data? Data Gaji Pegawai akan diubah mengikuti perubahan data absensi.</i>",
            "Konfirmasi",
          );
          result.then((dialogResult) => {
            if (dialogResult) this.settingLibur(e);
          });
        },
      },
    };
  },
  // async created() {
  //   await this.commonStore.preloadStores();
  // },

  async mounted() {
    // absenStore.dataSourceAbsen()
    this.dataSource = this.absenStore.dataSourceAbsen();
    this.getUrlFilter();
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },
  watch: {
    filterValue: function (newDateValue) {
      var rowIndex = dataGrid.getRowIndexByKey(options.key);
      // Perform any other actions you need with the updated date value
    },
  },
  async created() {
    let filter = null;
    if (!_.isNil(this.$route.query.filter)) {
      filter = this.$route.query.filter;
      filter = this.transformUrlToQuery(filter);
    }

    if (this.$route.query.action === "input" && this.can("absensi-create"))
      this.actionInput = true;

    this.absenStore.dataSourceAbsenList.filter(filter);
    await this.commonStore.preloadStores();
  },

  methods: {
    getOptions(data) {
      return [
        {
          text: "Detail Pegawai",
          pegawai_id: data.data.pegawai_id,
          row_key: data.key,
        },
        {
          text: "Absensi",
          pegawai_id: data.data.pegawai_id,
          row_key: data.key,
        },
        {
          text: "Riwayat Gaji",
          pegawai_id: data.data.pegawai_id,
          row_key: data.key,
        },
        {
          text: "Log Perubahan Data",
          pegawai_id: data.data.pegawai_id,
          row_key: data.key,
        },
        // other options...
      ];
    },

    async refreshPegawaiConfirm() {
      const date = DateTime.fromISO(this.refreshPegawaiTgl).setLocale("id");
      const selectedMonthName = date.monthLong + " " + date.year;

      const result = await confirm(
        "Refresh data pegawai di daftar absensi periode " +
          selectedMonthName +
          "?",
        "Refresh Data Pegawai",
      );

      if (result) {
        await this.refreshPegawai();
      }
    },

    async refreshPegawai() {
      this.popupLoadingVisible = true;
      this.popupLoadingTitle = "Refreshing Data Pegawai...";
      var data = {
        periode_absen: this.refreshPegawaiTgl,
      };

      try {
        const response = await api.post(`/absen_bulan_refresh_pegawai`, data);
        notify(response.data.message, "success");
        this.getAbsen();
        this.popupLoadingVisible = false;
        if (response.data.hapusAbsen.length > 0) {
          //Absen pegawai ini akan dihapus karena sudah tidak aktif bekerja di periode Bulan xxx
          const gajiExist = response.data.hapusAbsen.filter(
            (item) => item.gaji_exists === true,
          );
          const gajiNotExist = response.data.hapusAbsen.filter(
            (item) => item.gaji_exists === false,
          );

          this.popupWarningRefreshPegawaiText = "";
          if (gajiNotExist.length > 0) {
            this.popupWarningRefreshPegawaiText =
              "Pegawai " +
              gajiNotExist.map((item) => item.nama).join(", ") +
              " sudah tidak aktif bekerja di periode ini sehingga data absensi pegawai di periode ini dihapus.";
          }

          if (gajiExist.length > 0) {
            this.popupWarningRefreshPegawaiText =
              this.popupWarningRefreshPegawaiText +
              "<br><br>Pegawai " +
              gajiExist.map((item) => item.nama).join(", ") +
              " sudah tidak aktif bekerja di periode ini, namun masih memiliki data gaji. Tidak dapat menghapus data absensi pegawai ini. Hubungi admin untuk menghapus data gaji pegawai ini terlebih dahulu.";
          }

          if (this.popupWarningRefreshPegawaiText !== "") {
            this.popupWarningRefreshPegawaiVisible = true;
          }

          // notify(
          //   "Data absensi yang tidak sesuai dengan data pegawai telah dihapus: " +
          //     response.data.hapusAbsen.join(", "),
          //   "warning"
          // );
        }
        console.log("Refresh Data Pegawai Sukses", response);
      } catch (error) {
        console.error(error);
        notify(
          "Gagal Refresh Data Pegawai, " + error.response.data.message,
          "error",
        );
        this.popupLoadingVisible = false;
      }
    },

    toggleHeaderExpand() {
      this.isExpanded = !this.isExpanded;
    },
    setActionInput() {
      if (this.actionInput) this.actionInput = false;
      else if (this.can("absensi-create")) this.actionInput = true;
    },

    async absenCheckExists() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      await axios
        .post(
          `${API_BASE_URL}/absen_check_exists`,
          this.filters.tahun + "-" + this.filters.bulan + "-01",
          config,
        )
        .then((response) => {
          if (!response.data.status) {
            this.generateAbsen();
          } else {
            notify(response.data.message, "error");
          }
        })
        .catch((error) => {
          console.error("absenCheckExists error", error);
          notify(
            "Pengecekan absensi gagal. " + error.response.data.message,
            "error",
          );
        });
    },

    async generateAbsen() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };

      var data = {
        bulan: this.filters.bulan,
        tahun: this.filters.tahun,
        created_by_user_id: auth.getUser().id,
      };

      this.popupLoadingVisible = true;
      this.popupLoadingTitle = "Generating Absen...";
      await axios
        .post(`${API_BASE_URL}/absen_bulan_input`, data, config)
        .then((response) => {
          notify(response.data.message, "success");
          this.popupLoadingVisible = false;
          this.popupLoadingTitle = "Loading...";
          this.getAbsen();
        })
        .catch((error) => {
          this.popupLoadingVisible = false;
          this.popupLoadingTitle = "Loading...";
          console.error(error);
          notify("Gagal Generate Absen", "error");
        });
      this.popupLoadingVisible = false;
    },

    getAbsen() {
      // this.absenStore.dataSourceAbsenList.filter([
      //   [
      //     [
      //       "periode_absen",
      //       "=",
      //       this.filters.tahun + "-" + this.filters.bulan + "-01",
      //     ],
      //   ],
      // ]); gak ada efeknya
      if (this.$refs["dataGrid"] && this.$refs["dataGrid"].instance) {
        this.$refs["dataGrid"].instance.clearFilter();
        this.$refs["dataGrid"].instance.getDataSource().reload();
      }
    },
    confirmGenerateAbsen() {
      if (this.can("absensi-create")) this.popupGenerateVisible = true;
      else notify("Anda tidak memiliki akses untuk membuat absen", "error");
    },

    transformUrlToQuery(filterQueries) {
      const filters = Array.isArray(filterQueries)
        ? filterQueries
        : [filterQueries];

      // Check if 'and' or 'or' exists in filters
      const containsLogicalOperators = filters.some(
        (filter) => filter === "and" || filter === "or",
      );

      if (containsLogicalOperators) {
        // If 'and' or 'or' is found, proceed with transformation
        const transformedFilters = this.transformFilters(filters);

        // Use the transformed filters in your component logic
        return transformedFilters;
      } else {
        // Handle cases where no logical operator is present
        return filterQueries;
      }
    },
    transformFilters(filters) {
      // Initialize an empty array to hold the transformed filters
      const transformedFilters = [];

      // Iterate over the filters to transform them
      filters.forEach((filter) => {
        // Check if the filter is 'and' or 'or'
        if (filter === "and" || filter === "or") {
          transformedFilters.push(filter);
        } else {
          // Split the filter string into its components
          const filterParts = filter.split(",");
          transformedFilters.push(filterParts);
        }
      });

      return transformedFilters;
    },

    refreshDatagrid() {
      // this.absenStore.dataSourceAbsenList.filter(null);
      // this.$refs[gridRef].instance.getDataSource().reload();

      this.absenStore.dataSourceAbsenList.filter(null);
      if (this.$refs["dataGrid"] && this.$refs["dataGrid"].instance) {
        // this.$refs["dataGrid"].instance.clearFilter();
        this.$refs["dataGrid"].instance.getDataSource().reload();
      }

      this.buttonFilterPintasanVisible = false;
    },

    displayColumnValue(e, column) {
      let res = null;
      if (column === "jabatan_id")
        res = _.find(this.commonStore.jabatanStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "cabang_id")
        res = _.find(this.commonStore.cabangStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "unit_id")
        res = _.find(this.commonStore.unitStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "pegawai_status_id")
        res = _.find(this.commonStore.pegawaiStatusStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "bagian_id")
        res = _.find(this.commonStore.bagianStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "sub_bagian_id")
        res = _.find(this.commonStore.subBagianStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "bidang_id")
        res = _.find(this.commonStore.bidangStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "sub_bidang_id")
        res = _.find(this.commonStore.subBidangStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "seksi_id")
        res = _.find(this.commonStore.seksiStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      if (res) return res.nama;
      return "";
    },

    onContextMenuPreparing(e) {
      if (e.target == "content") {
        e.itemData = {
          pegawai_id: e.row.data.pegawai_id,
          row_key: e.row.data.id,
        };

        // e.items can be undefined
        if (e.row.isEditing) return;
        if (!e.items) e.items = [];
        e.items.push({
          text: "Lihat Detail Pegawai",
          icon: "user",
          onItemClick: () => {
            e.itemData.text = "Detail Pegawai";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Riwayat Gaji",
          icon: "money",
          onItemClick: () => {
            e.itemData.text = "Riwayat Gaji";
            this.onItemClick(e);
          },
        });
        e.items.push({
          text: "Log Perubahan Data",
          icon: "clock",
          onItemClick: () => {
            e.itemData.text = "Log Perubahan Data";
            this.$refs.logPopup.showBySubject(e.row.key, "AbsenBulan");
          },
        });
      }
    },
    onItemClick(e) {
      const pegawaiId = e.itemData.pegawai_id;
      const rowKey = e.itemData.row_key;

      if (e.itemData.text === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData.text === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "pegawai-detail-custom",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
      if (e.itemData.text === "Log Perubahan Data") {
        this.$refs.logPopup.showBySubject(rowKey, "AbsenBulan");
      }
    },
    getUrlFilter() {
      if (this.$route.query.filter) {
        this.buttonFilterPintasanVisible = true;
        let filter = this.$route.query.filter;
        if (!isNaN(filter[2]) && typeof +filter[2] === "number") {
          filter[2] = parseInt(this.$route.query.filter[2]);
        } else {
        }

        this.filterValue.push(filter);

        if (this.$route.query.filterPeriode !== undefined) {
          let filterPeriode = this.$route.query.filterPeriode;
          filterPeriode[2] = new Date(this.$route.query.filterPeriode[2]);

          this.filterValue.push(filterPeriode);
        }

        return filter;
      } else {
        //this.filterValue.push(["periode_absen", "=", new Date(currentDate)]);
      }
    },
    resetFilter() {
      this.filterValue = [];

      this.$refs["dataGrid"].instance.getDataSource().reload();
    },

    can,
    async settingLibur(e) {
      const result = e.validationGroup.validate();
      if (!result.isValid) return;
      this.settingLiburSource.direksi = this.nullOrZero(
        this.settingLiburSource.direksi,
      );
      this.settingLiburSource.tetap = this.nullOrZero(
        this.settingLiburSource.tetap,
      );
      this.settingLiburSource.capeg = this.nullOrZero(
        this.settingLiburSource.capeg,
      );
      this.settingLiburSource.honor = this.nullOrZero(
        this.settingLiburSource.honor,
      );
      this.settingLiburSource.kontrak = this.nullOrZero(
        this.settingLiburSource.kontrak,
      );

      try {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };

        const response = await axios.post(
          `${API_BASE_URL}/input_libur_massal`,
          this.settingLiburSource,
          config,
        );
        notify(response.data.message, response.data.notify_type);
        if (response.data.status) {
          this.refreshDatagrid();
          this.settingLiburSinkronGaji();
        }
      } catch (e) {
        console.error("error", e);
      }
      this.popupSettingLiburVisible = false;
    },
    buttonCan(permiss) {
      // return true;
      if (this.can(permiss)) return true;
      return false;
    },
    settingLiburDialog() {
      this.popupSettingLiburVisible = true;
    },

    detailPegawai(e) {
      // this.$router.push({
      //   name: "simpeg-pegawai-detail",
      //   query: { id: e.row.data.pegawai_id },
      // });
      const url = this.$router.resolve({
        name: "simpeg-pegawai-detail",
        query: { id: e.row.data.pegawai_id },
      }).href;
      window.open(url, "_blank");
    },

    onRowUpdatingLama(e) {
      // Prevent the default updating behavior until the async operation is complete
      const event = e;
      const updatedData = { ...e.oldData, ...e.newData };

      e.cancel = new Promise((resolve) => {
        (async () => {
          try {
            // Make the Axios call

            const config = {
              headers: {
                Authorization: api.defaults.headers.common["Authorization"],
                "content-type": "application/json",
              },
            };

            var data = {
              pegawai_id: event.oldData.pegawai_id,
              tgl_gaji: event.oldData.periode_absen,
            };
            const response = await axios.post(
              `${API_BASE_URL}/gaji_approve_get`,
              data,
              config,
            );

            // Check the response and decide whether to cancel the update
            if (response.data.data) {
              event.component.cancelEditData();

              notify(
                "Gaji pegawai sudah disetujui, tidak dapat mengubah kehadiran.",
                "error",
              );
              resolve(true); // Cancel the update
            } else {
              // Allow the update
              if (response.data.tidak_hadir !== updatedData.tidak_hadir) {
                await this.saveEditedDataToOData(
                  event.key,
                  event.newData,
                  event.oldData,
                );
              }
              // if (e.newData.tidak_hadir !== e.oldData.tidak_hadir) {

              // }
              // resolve(false);
              resolve(false); //kenapa aku pakai resolve(false) ?? bukannya edit dihandle oleh saveEditedDataToOData ??
              //ternyata karena resolve(false) akan mengcancel update, sehingga tombol save dihilangkan
            }
          } catch (error) {
            event.component.cancelEditData();
            notify("Gagal mengubah kehadiran.", "error");
            resolve(true); // Cancel the update on error
          }
        })();
      });
    },

    async onRowUpdating(e) {
      // Prevent the default updating behavior until the async operation is complete
      // const event = e;
      e.newData.updated_by_user_id = auth.getUser().id;
      // const updatedData = { ...e.oldData, ...e.newData };
      this.$refs["dataGrid"].instance.cancelEditData();
    },

    async onSaving(e) {
      e.cancel = true;
      this.$refs["dataGrid"].instance.cancelEditData();
      this.popupLoadingVisible = true;
      this.popupLoadingTitle = "Simpan dan Sinkronisasi Gaji...";

      try {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };

        const data = e.changes.map((change) => {
          if (change.type === "update") {
            return {
              ...change.data,
              id: change.key, // or your actual primary key
              updated_by_user_id: auth.getUser().id,
            };
          }
        });

        const response = await axios.post(
          `${API_BASE_URL}/customstore-absen-bulans/insert_mass`,
          data,
          config,
        );
        this.refreshDatagrid();
        this.popupLoadingVisible = false;
        this.popupLoadingTitle = "Loading...";
        notify(response.data.message, response.data.notify_type);
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        this.popupLoadingVisible = false;
        this.popupLoadingTitle = "Loading...";
        notify(
          "Gagal mengubah absen dan sinkronisasi gaji pegawai " + error,
          "error",
        );
      }
    },

    async settingLiburSinkronGaji() {
      this.popupLoadingVisible = true;
      this.popupLoadingTitle = "Simpan dan Sinkronisasi Gaji...";
      try {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };

        var data = {
          periode_absen: this.settingLiburSource.tgl,
          edited_by_user_id: auth.getUser().id,
        };

        const response = await axios.post(
          `${API_BASE_URL}/input_libur_massal_sinkron_gaji`,
          data,
          config,
        );
        notify(response.data.message, response.data.notify_type);
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        notify("Gagal sinkron gaji pegawai " + error, "error");
      }
      this.popupLoadingVisible = false;
      this.popupLoadingTitle = "Loading...";
    },

    formatStatusGaji(method, val) {
      if (
        typeof val === "undefined" ||
        val.data.value === null ||
        !val.data.value
      ) {
        if (method == "icon") return "edit";
        if (method == "type") return "danger";
      }
      if (val.data.value) {
        if (method == "icon") return "lock";
        if (method == "type") return "success";
      }

      return;
    },
    setCellValueCuti(newData, value) {
      newData.cuti = value;
    },
    setCellValueAlpa(newData, value, currentRowData) {
      newData.alpa = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.ijin) +
        this.nullOrZero(currentRowData.sakit);
      // +this.nullOrZero(currentRowData.libur);
    },
    setCellValueIjin(newData, value, currentRowData) {
      newData.ijin = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.sakit) +
        this.nullOrZero(currentRowData.alpa);
      // +this.nullOrZero(currentRowData.libur);
    },
    // setCellValueLibur(newData, value, currentRowData) {
    //   newData.libur = value;
    //   newData.tidak_hadir =
    //     this.nullOrZero(value) +
    //     this.nullOrZero(currentRowData.sakit) +
    //     this.nullOrZero(currentRowData.alpa);
    // },
    setCellValueSakit(newData, value, currentRowData) {
      newData.sakit = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.ijin) +
        this.nullOrZero(currentRowData.alpa);
    },
    nullOrZero(num) {
      if (num === null) return 0;
      return parseInt(num);
    },
    formatMonth(e) {
      const isoDateString = e.split("/").reverse().join("-") + "-01";
      const date = DateTime.fromISO(isoDateString).setLocale("id");
      return date.monthLong + " " + date.year;
    },

    editingStart(e) {
      if (
        e.column.dataField === "hadir" ||
        e.column.dataField === "sakit" ||
        e.column.dataField === "ijin" ||
        e.column.dataField === "alpa" ||
        e.column.dataField === "cuti" ||
        e.column.dataField === "libur"
      ) {
        e.cancel = false;
      } else {
        e.cancel = true;
      }
    },

    oneditorpreparing(e) {
      if (e.parentType === "dataRow") {
        // if (e.row.data.status_gaji) e.editorOptions.disabled = true;
        if (e.row.data.gajis !== null) {
          if (e.row.data.gajis_status_gaji) {
            e.editorOptions.disabled = true;
            return;
          }
        }
      }
      if (e.dataField === "periode_absen") {
        e.editorOptions.calendarOptions = {
          minZoomLevel: "year",
          maxZoomLevel: "year",
          displayFormat: "MM/yyyy",
          type: "month",
        };
      }
      if (
        e.parentType === "dataRow" &&
        (e.dataField === "hadir" ||
          e.dataField === "sakit" ||
          e.dataField === "ijin" ||
          e.dataField === "alpa" ||
          e.dataField === "cuti" ||
          e.dataField === "libur")
      ) {
        e.editorOptions.disabled = false;
      } else if (e.parentType === "dataRow") {
        e.editorOptions.disabled = true;
      }

      return;
    },

    onPageChanged(e, gridRef) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs[gridRef].instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Absen");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Absen Pegawai.xlsx",
          );
        });
      });
      e.cancel = true;
    },
  },
};

// function hasFilterNestedTable(str) {
//   return (
//     _.includes(str, "/") ||
//     _.includes(str, "[") ||
//     _.includes(str, "]") ||
//     _.includes(str, "riwayatPekerjaan/") ||
//     _.includes(str, "riwayatGolongan/") ||
//     _.includes(str, "pegawai/") ||
//     _.includes(str, "gajis/")
//   );
// }

// function convertFilterPegawai(filter) {

//   var searchTerm = (filter.match(
//     /contains\(tolower\(pegawai\/nama\),'([^']+)'/
//   ) || [])[1];
//   var replacedString = filter.replace(
//     /contains\(tolower\(pegawai\/nama\),'([^']+)'/,
//     `pegawai/any(s:(contains(tolower(s/nama),'${searchTerm}'))`
//   );

//   var searchTermNik = (replacedString.match(
//     /contains\(tolower\(pegawai\/nik\),'([^']+)'/
//   ) || [])[1];
//   var replacedStringNik = replacedString;

//   replacedStringNik = replacedString.replace(
//     /contains\(tolower\(pegawai\/nik\),'([^']+)'/,
//     `pegawai/any(s:(contains(tolower(s/nik),'${searchTermNik}'))`
//   );

//   return replacedStringNik;
// }

// function convertFilter(filter, regVar) {
//   // const regex = new RegExp(`${regVar}\/(\\w+) eq (\\d+)`, "g"); //utk detect riwayatPekerjaan/cabang_id eq 2
//   // const regex = new RegExp(`${regVar}/(\\w+) eq (\\d+)`, "g");
//   const regex = new RegExp(`${regVar}/(\\w+) eq (\\S+)`, "g");
//   const outputString = filter.replace(regex, (match, p1, p2) => {
//     return `${regVar}/any(s:s/${p1} eq ${p2})`;
//   });
//   return outputString;
// }
</script>
